import * as React from 'react';
import ErrorBoundary from './ErrorBoundary';

export function wrapWithErrorBoundary(
  components: Record<string, React.ComponentType<any>>
): Record<string, React.ComponentType<any>> {
  const wrapped: Record<string, React.ComponentType<any>> = {};

  for (const [name, Component] of Object.entries(components)) {
    const WrappedComponent: React.FC<any> = (props) => (
      <ErrorBoundary componentName={name}>
        <Component {...props} />
      </ErrorBoundary>
    );
    WrappedComponent.displayName = `ErrorBoundary(${name})`;
    wrapped[name] = WrappedComponent;
  }

  return wrapped;
}
